const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register() {
  if ('serviceWorker' in navigator) {
   //const swUrl = `https://ecoach.etrueconcept.com/service-worker.js`;
 const swUrl = `https://app.ecoachpro.net/service-worker.js`;
    window.addEventListener('load', () => {
      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then(reg => console.log('Service Worker Registered:', reg.scope))
    .catch(error => console.error('Service Worker Error:', error));
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Service Worker not found');
      }
      registerValidSW(swUrl);
    })
    .catch(() => console.log('No Service Worker found.'));
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
